import PdfUtils from "./pdfUtils";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { isEmpty } from "lodash";
import DataUtils from "./dataUtils";

export default class FaxUtils {
  static faxSend = (patientDetails, uploadedFileObjects, referralDetails, currentUser) => {
    return PdfUtils.generatePatientDetailsPDF(
      patientDetails,
      uploadedFileObjects,
      referralDetails,
      '',
      currentUser,
      true,
    );
  };

  static faxNewFiles = (patientDetails, documents, referralDetails, currentUser) => {
    return new Promise((resolveVal, reject) => {
      PdfUtils.preparePdf(
        documents,
        patientDetails,
        referralDetails,
        resolveVal,
        '',
        currentUser,
        true,
      );
    });
  };

  static sendFaxMessage = (referralDetails, message, patientDetails, currentUser) => {
    return new Promise(function (resolve, reject) {
      let iframe = window.document.createElement('iframe');
      iframe.style.visibility = 'hidden';
      iframe.style.width = '216mm';
      iframe.style.margin = '0';
      window.document.body.appendChild(iframe);
      let iframedoc = iframe.contentDocument || iframe.contentWindow.document;
      var innerHTML = FaxUtils.faxMessageFormat(
        referralDetails,
        message,
        patientDetails,
        currentUser,
      );
      iframedoc.body.innerHTML = innerHTML;
      const doc = new jsPDF({
        format: 'a4',
        unit: 'mm',
      });

      html2canvas(iframedoc.body, {
        scale: 2,
        useCORS: true,
        logging: true,
        allowTaint: true,
      }).then(canvas => {
        let imgData = canvas.toDataURL('image/jpeg');

        var percent = doc.internal.pageSize.getWidth() / canvas.width;
        doc.addImage(
          imgData,
          'JPEG',
          0,
          0,
          doc.internal.pageSize.getWidth(),
          percent * canvas.height,
          null,
          'MEDIUM',
        );

        let blob = doc.output('blob');
        window.document.body.removeChild(iframe);
        resolve(blob);
      });
    });
  };

  static faxMessageFormat = (referralDetails, message, patientDetails, currentUser) => {
    var referral = {};
    if (!isEmpty(referralDetails?.referral) && isEmpty(referralDetails?.referral?.referral)) {
      referral = referralDetails?.referral;
    } else if (!isEmpty(referralDetails?.referral?.referral)) {
      referral = referralDetails?.referral?.referral;
    } else {
      return '';
    }

    var innerHTML = '';
    innerHTML += DataUtils.getHeader(true, referral);

    innerHTML += DataUtils.getReferreringClinic(referral);

    innerHTML += DataUtils.getAddress(referral);

    innerHTML += DataUtils.getContactPerson(null, currentUser);

    innerHTML += DataUtils.getFaxAndPhoneNumber(referral);

    innerHTML += '<hr/>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" +
      'Provider: ' +
      referralDetails.provider.display_name +
      '</span></section>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" +
      'Patient Name: ' +
      patientDetails.patient.full_name +
      '</span></section>';

    innerHTML += '<hr/>';

    innerHTML +=
      "<section class='sheet' style='padding: 4 12;'><span style='font-weight: bold;'>" +
      'Message: ' +
      message +
      '</span></section>';

    innerHTML += '<hr/>';

    innerHTML += '</div></body></html>';

    return innerHTML;
  };
}
